import React from 'react';

const TemplateCard = ({ templateData }) => {
  const { approvalSection } = templateData;
  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow p-6 mt-6">
      <h4 className="text-xl font-semibold mb-4">{templateData.templateType}</h4>
      <div className="mb-4">
        <h5 className="text-lg font-semibold">Title:</h5>
        <p className="text-gray-700">{templateData.title}</p>
      </div>
      {templateData.auditTitle && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Audit Title:</h5>
          <p className="text-gray-700">{templateData.auditTitle}</p>
        </div>
      )}
      {templateData.background && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Background:</h5>
          <p className="text-gray-700">{templateData.background}</p>
        </div>
      )}
      {templateData.objectives && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Objectives:</h5>
          <ul className="list-disc list-inside">
            {templateData.objectives.map((obj, index) => (
              <li key={index} className="text-gray-700">{obj}</li>
            ))}
          </ul>
        </div>
      )}
      {templateData.scope && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Scope:</h5>
          {templateData.scope.inScope && (
            <div className="mb-2">
              <p className="font-semibold">In-Scope:</p>
              <p className="text-gray-700">
                <span className="font-semibold">Departments:</span> {templateData.scope.inScope.departments}
              </p>
              <p className="text-gray-700">
                <span className="font-semibold">Processes:</span> {templateData.scope.inScope.processes}
              </p>
              <p className="text-gray-700">
                <span className="font-semibold">Time Period:</span> {templateData.scope.inScope.timePeriod}
              </p>
            </div>
          )}
          {templateData.scope.outOfScope && (
            <>
              <p className="font-semibold">Out-of-Scope:</p>
              <p className="text-gray-700">{templateData.scope.outOfScope}</p>
            </>
          )}
        </div>
      )}
      {templateData.limitations && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Limitations:</h5>
          <p className="text-gray-700">{templateData.limitations}</p>
        </div>
      )}
      {templateData.keyStakeholders && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Key Stakeholders:</h5>
          <p className="text-gray-700">{templateData.keyStakeholders}</p>
        </div>
      )}
      {approvalSection && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Approval Section:</h5>
          {approvalSection.preparedBy && (
            <p className="text-gray-700">
              <span className="font-semibold">Prepared by:</span> {approvalSection.preparedBy}
            </p>
          )}
          {approvalSection.date && (
            <p className="text-gray-700">
              <span className="font-semibold">Date:</span> {approvalSection.date}
            </p>
          )}
          {approvalSection.reviewedBy && (
            <p className="text-gray-700">
              <span className="font-semibold">Reviewed by:</span> {approvalSection.reviewedBy.name} ({approvalSection.reviewedBy.title}, {approvalSection.reviewedBy.dateOfReview})
            </p>
          )}
          {approvalSection.signOff && (
            <p className="text-gray-700">
              <span className="font-semibold">Sign-Off:</span> {approvalSection.signOff}
            </p>
          )}
        </div>
      )}
      {templateData.objective && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Objective:</h5>
          <p className="text-gray-700">{templateData.objective}</p>
        </div>
      )}
      {templateData.riskIdentification && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Risk Identification:</h5>
          {templateData.riskIdentification.map((risk, index) => (
            <div key={index} className="mb-2">
              <p className="font-semibold">Risk Area: {risk.riskArea}</p>
              <p className="text-gray-700">Description: {risk.description}</p>
              <p className="text-gray-700">Potential Impact: {risk.potentialImpact}</p>
              <p className="text-gray-700">Likelihood: {risk.likelihood}</p>
            </div>
          ))}
        </div>
      )}
      {templateData.riskAnalysis && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Risk Analysis:</h5>
          <p className="text-gray-700">
            <span className="font-semibold">Risk Score:</span> {templateData.riskAnalysis.riskScore}
          </p>
          <p className="text-gray-700">
            <span className="font-semibold">Mitigation Measures:</span> {templateData.riskAnalysis.mitigationMeasures}
          </p>
        </div>
      )}
      {templateData.summary && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Summary:</h5>
          <p className="text-gray-700">{templateData.summary}</p>
        </div>
      )}
      {templateData.appendix && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Appendix:</h5>
          <p className="text-gray-700">{templateData.appendix}</p>
        </div>
      )}
      {templateData.auditObjectives && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Audit Objectives:</h5>
          <ul className="list-disc list-inside">
            {templateData.auditObjectives.map((obj, index) => (
              <li key={index} className="text-gray-700">{obj}</li>
            ))}
          </ul>
        </div>
      )}
      {templateData.methodology && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Methodology:</h5>
          <p className="text-gray-700">
            <span className="font-semibold">Approach:</span> {templateData.methodology.approach}
          </p>
          <p className="text-gray-700">
            <span className="font-semibold">Procedures:</span> {templateData.methodology.procedures}
          </p>
          <p className="text-gray-700">
            <span className="font-semibold">Tools & Techniques:</span> {templateData.methodology.toolsAndTechniques}
          </p>
        </div>
      )}
      {templateData.timelineAndMilestones && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Timeline and Milestones:</h5>
          <p className="text-gray-700">{templateData.timelineAndMilestones}</p>
        </div>
      )}
      {templateData.resourcesAndTeam && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Resources and Team:</h5>
          <p className="text-gray-700">{templateData.resourcesAndTeam}</p>
        </div>
      )}
      {templateData.deliverables && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Deliverables:</h5>
          <p className="text-gray-700">{templateData.deliverables}</p>
        </div>
      )}
      {templateData.monitoringAndAdjustments && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Monitoring and Adjustments:</h5>
          <p className="text-gray-700">{templateData.monitoringAndAdjustments}</p>
        </div>
      )}
      {templateData.reviewAndFeedback && (
        <div className="mb-4">
          <h5 className="text-lg font-semibold">Review and Feedback:</h5>
          <p className="text-gray-700">{templateData.reviewAndFeedback}</p>
        </div>
      )}
    </div>
  );
};

export default TemplateCard;
